import { useEffect, useState } from "react";

export const findDragDropFile = (items: DataTransferItemList)=>{
    if (items) {
        const foundFile = [...items].find((item, i) => {
            if (item.kind === "file") {
                return true;
            }
        });
        return foundFile;
    }
    return null
}

export const useDragFile = ()=>{
    const [windowDragFile, setWindowDragFile] = useState<DataTransferItem>(null);
    
    useEffect(()=>{
        const handleDragOver = (e: DragEvent)=>{
            e.preventDefault();
            const foundFile = findDragDropFile(e.dataTransfer.items)
            if (foundFile){
                setWindowDragFile(foundFile);
            } else {
                setWindowDragFile(null);
            }
        };

        const handleDragLeave=(e: DragEvent)=>{
            if (!(e.relatedTarget as HTMLElement)?.closest('html')){
                setWindowDragFile(null)
            }
        }

        const handleDragEnd=(e: DragEvent)=>setWindowDragFile(null)

        window.addEventListener('dragover', handleDragOver);
        window.addEventListener('dragleave', handleDragLeave);
        window.addEventListener('dragend', handleDragEnd);
        window.addEventListener('drop', handleDragEnd);

        return ()=>{
            window.removeEventListener('dragover', handleDragOver);
            window.removeEventListener('dragleave', handleDragLeave);
            window.removeEventListener('dragend', handleDragEnd);
            window.removeEventListener('drop', handleDragEnd);
        }
    },[]);

    return windowDragFile;
}